import { render } from "./PureView.vue?vue&type=template&id=6a91d409&scoped=true"
import script from "./PureView.vue?vue&type=script&lang=js"
export * from "./PureView.vue?vue&type=script&lang=js"

import "./PureView.vue?vue&type=style&index=0&id=6a91d409&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a91d409"]])

export default __exports__